export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-27-997be7e86affaacab4676d651d13ed0d.jpg";